export const formatDate = (value) => {
  if (value === null) {
    return "";
  } else {
    value = String(value);
    return value.substring(5, 7) + "/" + value.substring(8, 10) + "/" + value.substring(0, 4);
  }
}

export const formatYMD = (value) => {
  if (value === null) {
    return "";
  } else {
    const dt = new Date(value);
    const m = "0" + String(dt.getMonth() + 1);
    const d = "0" + String(dt.getDate());
    const y = String(dt.getFullYear());
    return y + "-" + m.slice(-2) + "-" + d.slice(-2);
  }
}



export const formatNumber = (value, decimals, commas) => {
  if (commas) {
    return Number(value).toFixed(decimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  } else {
    return Number(value).toFixed(decimals);
  }
}

export const formatMoney = (value) => {
  return Number(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export const formatBoolean = (value) => {
  if (value) {
    return "Yes";
  } else {
    return "No";
  }
}

export const formatETime = (value) => {
  if (value === null) {
    return "";
  } else {
    value = String(value);
    return value.substring(2, 4) + "-" + value.substring(4, 6) + "-20" + value.substring(0, 2);
  }
}

export const stringifyNulls = (value) => {
  if (value === null) {
    return "";
  } else {
    return String(value);
  }
}

